(function () {
    'use strict';

    angular
        .module('app')
        .controller('loginForgetPwdDirectEditPwdController', loginForgetPwdDirectEditPwdController);

    function loginForgetPwdDirectEditPwdController(sysCode, loginService, $location, $rootScope, $routeParams, $scope) {

        var vm = this;
        vm.submit = submit;
        vm.isValidLink = false;

        // virtual keyboard start
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.isShowConfirmPwdVirKey = false;
        vm.textChanged = textChanged;
        vm.focusObj = null
        vm.virData = null;

        vm.getFocusNewPwd = function () {
            vm.focusObj = "newPwd";
            vm.virData = vm.data.newPwd;
        }
        vm.getFocusConfirmPwd = function () {
            vm.focusObj = "confirmPwd";
            vm.virData = vm.data.confirmPwd;
        }

        function textChanged(newPwd) {
            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            var $e = angular.element(e);
            $e.triggerHandler('input');
        }

        function showVirKey() {
            if (vm.isShowVirKey)
                vm.isShowVirKey = false;
            else
                vm.isShowVirKey = true;

        }

        onInit();

        function onInit() {

            let param = {
                userAccount: $routeParams.userAccount /*crypted*/ ,
                verifyCode: $routeParams.verifyCode /*crypted*/
            };

            // check verify code 
            loginService.checkVerifyCode(param).then(function (data) {

                // console.log(data);
                if (data.data.Result === "100") {

                    vm.data = {
                        userAccount: data.data.userAccount,
                        verifyCode: data.data.verifyCode,
                        sysCode: sysCode
                    };

                    // show input box 
                    vm.isValidLink = true;

                } else {

                    // show error message
                    toastr.error(data.data.ResultMsg);

                }

            });


        }

        function submit() {
            //console.log(vm.data);
            vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            if (!vm.confirmPwd) {
                loginService.directModifyUserPassword(vm.data).then(function (data) {
                    if (data) {
                        toastr.success($rootScope.translate.commonEditPwdSuccess);
                        removeSsoInfo();
                        $location.path('/login');
                    }
                });
            }
        }

    }
})();